module.exports = __webpack_public_path__ + "static/media/bg3.39c52722.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/bg3.png
// module id = 404
// module chunks = 0